// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_w5-8";
export var editMode = "_w5-3";
export var headerRow = "_w5-a";
export var headerTitle = "_w5-b";
export var product = "_w5-1";
export var productDetails = "_w5-5";
export var productDivider = "_w5-7";
export var productImage = "_w5-2";
export var productInfo = "_w5-4";
export var productTitle = "_w5-6";
export var strikethrough = "_w5-9";
export var upsellProductsCard = "_w5-0";